import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error kada korisnik počne tipkati
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Molimo unesite vaše ime";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Molimo unesite email adresu";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Molimo unesite važeću email adresu";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Molimo unesite poruku";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      // Fokusiraj prvo polje sa greškom
      const firstErrorField = Object.keys(errors)[0];
      document.getElementById(firstErrorField)?.focus();
      return;
    }

    setStatus("sending");

    const serviceID = "service_jvlnvdw";
    const templateID = "template_1oqbyjk";
    const publicKey = "C6utMyAv985fwb7sd";

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then(() => {
        setStatus("success");
        setFormData({ name: "", email: "", phone: "", message: "" });
        setTimeout(() => setStatus(""), 5000);
      })
      .catch(() => {
        setStatus("error");
        setTimeout(() => setStatus(""), 5000);
      });
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <h2 className="section-title">Kontaktirajte nas</h2>

        <Row className="g-4">
          <Col lg={6}>
            <div
              className="contact-box"
              role="complementary"
              aria-label="Kontakt informacije"
            >
              <h3>Javite nam se!</h3>
              <p>
                Rado ćemo odgovoriti na sva vaša pitanja i pomoći vam
                organizirati savršen event za vašu djecu.
              </p>

              <div className="contact-detail-item">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="contact-icon"
                  aria-hidden="true"
                />
                <div>
                  <h4>Telefon</h4>
                  <a
                    href="tel:+385993152678"
                    aria-label="Pozovi nas na broj 099 315 2678"
                  >
                    +385 99 3152 678
                  </a>
                </div>
              </div>

              <div className="contact-detail-item">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="contact-icon"
                  aria-hidden="true"
                />
                <div>
                  <h4>Email</h4>
                  <a
                    href="mailto:marina@babyzoogarden.com"
                    aria-label="Pošalji email na marina@babyzoogarden.com"
                  >
                    marina@babyzoogarden.com
                  </a>
                </div>
              </div>

              <div className="contact-detail-item">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="contact-icon"
                  aria-hidden="true"
                />
                <div>
                  <h4>Lokacija</h4>
                  <p>Zagreb, Hrvatska</p>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className="contact-box">
              <h3 id="contact-form-title">Pošaljite nam poruku</h3>
              <form
                onSubmit={handleSubmit}
                className="contact-form"
                aria-labelledby="contact-form-title"
                noValidate
              >
                <div className="form-group">
                  <label htmlFor="name" className="visually-hidden">
                    Vaše ime (obavezno)
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Vaše ime *"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className={`form-input ${errors.name ? "error" : ""}`}
                    aria-required="true"
                    aria-invalid={errors.name ? "true" : "false"}
                    aria-describedby={errors.name ? "name-error" : undefined}
                  />
                  {errors.name && (
                    <span
                      id="name-error"
                      className="error-message"
                      role="alert"
                    >
                      {errors.name}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="visually-hidden">
                    Email adresa (obavezno)
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email adresa *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className={`form-input ${errors.email ? "error" : ""}`}
                    aria-required="true"
                    aria-invalid={errors.email ? "true" : "false"}
                    aria-describedby={errors.email ? "email-error" : undefined}
                  />
                  {errors.email && (
                    <span
                      id="email-error"
                      className="error-message"
                      role="alert"
                    >
                      {errors.email}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="phone" className="visually-hidden">
                    Broj telefona (opciono)
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Broj telefona"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                    aria-label="Broj telefona, opciono polje"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="visually-hidden">
                    Vaša poruka (obavezno)
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Vaša poruka *"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className={`form-input ${errors.message ? "error" : ""}`}
                    aria-required="true"
                    aria-invalid={errors.message ? "true" : "false"}
                    aria-describedby={
                      errors.message ? "message-error" : undefined
                    }
                  ></textarea>
                  {errors.message && (
                    <span
                      id="message-error"
                      className="error-message"
                      role="alert"
                    >
                      {errors.message}
                    </span>
                  )}
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={status === "sending"}
                  aria-label={
                    status === "sending"
                      ? "Slanje poruke u tijeku"
                      : "Pošalji poruku"
                  }
                >
                  {status === "sending" ? (
                    <>
                      <span aria-hidden="true">Šaljem...</span>
                      <span className="visually-hidden">
                        Slanje poruke u tijeku, molimo pričekajte
                      </span>
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faPaperPlane} aria-hidden="true" />{" "}
                      Pošalji poruku
                    </>
                  )}
                </button>

                {status === "success" && (
                  <div
                    className="status-message success"
                    role="status"
                    aria-live="polite"
                  >
                    ✓ Poruka uspješno poslana!
                  </div>
                )}

                {status === "error" && (
                  <div
                    className="status-message error"
                    role="alert"
                    aria-live="assertive"
                  >
                    ✗ Greška prilikom slanja. Molimo pokušajte ponovo.
                  </div>
                )}
              </form>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default Contact;
